import request from '@/utils/request'
export function getMainList(regionCode) {
  return request({
    url: '/api/manual/showMainList',
    method: 'get',
    params: {
      regionCode,
    },
  })
}
export function reverseStart(params) {
  return request({
    url: '/api/workstation/reverseStart',
    nonstandard: true,
    method: 'get',
    params,
  })
}
export function showAndonList(params) {
  return request({
    url: '/api/andon/showAndonList',
    nonstandard: true,
    method: 'get',
    params,
  })
}
